import { render, staticRenderFns } from "./tcrgSet.vue?vue&type=template&id=bbcc959e&scoped=true&"
import script from "./tcrgSet.vue?vue&type=script&lang=js&"
export * from "./tcrgSet.vue?vue&type=script&lang=js&"
import style0 from "./tcrgSet.vue?vue&type=style&index=0&id=bbcc959e&prod&lang=scss&scoped=true&"
import style1 from "./tcrgSet.vue?vue&type=style&index=1&id=bbcc959e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcc959e",
  null
  
)

export default component.exports